module.exports = __webpack_public_path__ + "img/eres_8_steps_v2_fr.2ea13c7c.png";